var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmericanExpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 31.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -143.44,
    cy: 297.66,
    r: 29.85,
    gradientTransform: "matrix(1, 0, 0, -1, 149.05, 303.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9dd5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#98d3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#89cef3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#70c6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4ebbea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#23ade3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0da6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e77bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.81,0H0V31.93H31.81V21.39a1.18,1.18,0,0,0,.19-.7,1.06,1.06,0,0,0-.19-.7",
    style: {
      fill: "url(#radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87,13.82l-.61-1.5-.61,1.5m14.7-.6a.77.77,0,0,1-.44.08H14.82v-.83h1.1a1,1,0,0,1,.43.06.42.42,0,0,1,0,.69Zm7.75.6-.62-1.5-.62,1.5ZM9.65,15.43H8.74V12.5L7.44,15.43H6.65L5.35,12.5v2.93H3.53l-.34-.84H1.33L1,15.43H0l1.6-3.74H2.94l1.52,3.54V11.69H5.92l1.17,2.54,1.08-2.54H9.65v3.74Zm3.66,0h-3V11.69h3v.78h-2.1v.67h2v.77h-2v.75h2.1Zm4.21-2.73a1,1,0,0,1-.63,1,1.12,1.12,0,0,1,.44.32,1,1,0,0,1,.15.68v.74h-.9V15c0-.23,0-.55-.14-.73a.88.88,0,0,0-.65-.16h-1v1.36h-.89V11.69H16a2.1,2.1,0,0,1,1.09.18A.87.87,0,0,1,17.52,12.7ZM19,15.43H18V11.69H19Zm10.58,0H28.27l-1.7-2.81v2.81H24.75l-.35-.84H22.55l-.34.84H21.16A1.9,1.9,0,0,1,19.87,15a1.87,1.87,0,0,1-.48-1.43,2,2,0,0,1,.48-1.47,1.85,1.85,0,0,1,1.36-.43h.86v.8h-.84a.86.86,0,0,0-.69.22,1.21,1.21,0,0,0-.26.85,1.28,1.28,0,0,0,.25.88.83.83,0,0,0,.62.19h.4l1.26-2.94h1.34l1.51,3.54V11.69h1.37l1.57,2.6v-2.6h.91v3.74ZM0,16.16H1.53l.34-.83h.77l.35.83H6v-.63l.27.64H7.82l.27-.65v.64h7.47V14.8h.14c.1,0,.13,0,.13.18v1.18H19.7v-.31a3.13,3.13,0,0,0,1.43.31h1.62l.35-.83h.77l.34.83h3.14v-.79l.47.79h2.51V11H27.85v.61L27.5,11H25v.61L24.63,11H21.19a3.1,3.1,0,0,0-1.49.3V11H17.32v.3a1.48,1.48,0,0,0-1-.3H7.63l-.58,1.34L6.45,11H3.71v.61L3.41,11H1.08L0,13.43v2.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.81,18.92H30.18a.63.63,0,0,0-.36.07.3.3,0,0,0-.13.27.29.29,0,0,0,.19.28,1.16,1.16,0,0,0,.35,0h.48a1.44,1.44,0,0,1,1,.31.34.34,0,0,1,.08.09m0,1.4a1.39,1.39,0,0,1-1.21.48H28.87v-.8h1.72A.5.5,0,0,0,31,21a.32.32,0,0,0,.11-.24.33.33,0,0,0-.11-.25.46.46,0,0,0-.32-.08c-.84,0-1.88,0-1.88-1.16,0-.54.34-1.11,1.28-1.11h1.78v-.75H30.16a1.82,1.82,0,0,0-1.12.31v-.31H26.59a1.7,1.7,0,0,0-1.07.31v-.31H21.15v.31a2.33,2.33,0,0,0-1.2-.31H17.06v.31a2,2,0,0,0-1.26-.31H12.58l-.74.8-.69-.8H6.33V22.6h4.73l.76-.81.71.81h2.92V21.38h.28A3.05,3.05,0,0,0,17,21.19V22.6h2.4V21.24h.12c.15,0,.16,0,.16.16v1.2H27a2.11,2.11,0,0,0,1.21-.33v.33H30.5a3,3,0,0,0,1.31-.24v-1ZM28.24,19.9a1,1,0,0,1,.27.79c0,.8-.5,1.18-1.4,1.18H25.37v-.8H27.1a.55.55,0,0,0,.37-.1.31.31,0,0,0,.1-.24.33.33,0,0,0-.11-.25.46.46,0,0,0-.32-.08c-.83,0-1.88,0-1.88-1.16,0-.54.34-1.11,1.28-1.11h1.79v.79H26.69a.63.63,0,0,0-.36.07.3.3,0,0,0-.13.27.29.29,0,0,0,.19.28,1.16,1.16,0,0,0,.35,0h.48A1.44,1.44,0,0,1,28.24,19.9Zm-8.06-.24a.87.87,0,0,1-.44.08H18.65V18.9h1.1a.83.83,0,0,1,.43.07.35.35,0,0,1,.18.33A.41.41,0,0,1,20.18,19.66Zm.54.47a.87.87,0,0,1,.43.31,1.08,1.08,0,0,1,.15.69v.74h-.89V21.4c0-.22,0-.56-.15-.73s-.33-.17-.66-.17h-1v1.37h-.9V18.13h2.06a2.29,2.29,0,0,1,1.08.17.89.89,0,0,1,.46.83A1.05,1.05,0,0,1,20.72,20.13Zm1.13-2h3v.77H22.74v.68h2v.76h-2v.75h2.09v.78h-3Zm-6,1.72H14.66v-1h1.16c.33,0,.55.13.55.46S16.16,19.85,15.81,19.85Zm-2,1.68L12.39,20l1.38-1.47Zm-3.55-.44H8v-.75h2v-.76H8V18.9h2.25l1,1.09Zm7.11-1.73c0,1-.77,1.25-1.56,1.25H14.66v1.26H12.92l-1.1-1.24-1.14,1.24H7.13V18.13h3.6l1.1,1.22L13,18.13h2.85C16.53,18.13,17.33,18.32,17.33,19.36Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.40628217.svg";
export { ForwardRef as ReactComponent };